import { BaseIdentity } from "./base-identity";
import { IdentityTypeNameDecorator } from "./decorators/identity-type-name.decorator";

@IdentityTypeNameDecorator('DynamicInternalIdentity')
export class DynamicInternalIdentity extends BaseIdentity {

}
